/* @flow */
import ChatMessageStore from 'chat/stores/ChatMessageStore';
import CurrentUser from 'auth/CurrentUser';
import DeliveryModalContainer from 'chat/containers/DeliveryModalContainer.jsx';
import DeliveryStore from 'stores/DeliveryStore';
import React from 'react';
import ReadReceipt from 'chat/components/ReadReceipt.jsx';
import { ChatMessage } from 'entities/ChatMessage';
import { DeliveryStatus } from 'chat/constants/DeliveryConstants';
import { mountModal } from 'lib/modal.js';

import linkStateWithStores from 'components/mixins/linkStateWithStores';

import './styles/ChatReadReceipt.scss';

const ChatReadReceipt = React.createClass({
  propTypes: {
    message: React.PropTypes.instanceOf(ChatMessage).isRequired,
    labelDisplay: React.PropTypes.bool,
    glyphDisplay: React.PropTypes.bool,
    hovered: React.PropTypes.bool,
  },

  mixins: [
    linkStateWithStores([DeliveryStore, ChatMessageStore]),
  ],

  getDefaultProps() {
    return {
      labelDisplay: true,
    };
  },

  getInitialState() {
    return this.getStateFromStores();
  },

  getLastMessageReceivedSequence() {
    const chatMessages = this.state.messages.filter(message => {
      return (
        message instanceof ChatMessage &&
        message.getSender().id !== CurrentUser.getUser().id
      );
    }).sort((a, b) => {
      return b.getSeq() - a.getSeq();
    });

    if (chatMessages && chatMessages[0]) {
      return chatMessages[0].getSeq();
    }
  },

  getStateFromStores() {
    return {
      delivery: DeliveryStore.getDeliveryByMessageId(this.props.message.id),
      marker: DeliveryStore.getMarkerForStream(this.props.message.getChatId()),
      messages: ChatMessageStore.getChatMessages(this.props.message.getChatId()),
    };
  },

  showDeliveryModal() {
    mountModal(<DeliveryModalContainer message={this.props.message} />, this);
  },

  render() {
    if (!this.state.delivery) {
      return null;
    }

    if (!this.state.delivery.getReadSummary()) {
      return null;
    }

    // we only display a read receipt before the
    // last received message when item is hovered.
    const shouldHide = (
      !this.props.hovered &&
      // $FlowFixMe
      this.getLastMessageReceivedSequence() > this.props.message.getSeq()
    );

    if (shouldHide) {
      return null;
    }

    /* If we received a marker for that stream about the readSeq
     * then we show all previous message as read. The "read" status
     * will show up in the read summary otherwise!
     */
    const shouldBeMarkAsRead = (
      this.state.marker &&
      this.state.marker.readSeq >= this.props.message.getSeq()
    );

    const status = shouldBeMarkAsRead ?
      DeliveryStatus.READ :
      this.state.delivery.getReadSummary().getState();

    return (
      <div className="ChatReadReceipt">
        {status &&
          <span>
            {this.props.labelDisplay &&
              <span className="ChatReadReceipt-spacer">{' • '}</span>
            }
            <ReadReceipt
              labelDisplay={this.props.labelDisplay}
              glyphDisplay={this.props.glyphDisplay}
              errorCount={this.state.delivery.getReadSummary().getFailedCount()}
              status={status}
              onClick={status === DeliveryStatus.DELIVERY_ERROR ? this.showDeliveryModal : null}
            />
          </span>
        }
      </div>
    );
  },
});

export default ChatReadReceipt;



// WEBPACK FOOTER //
// ./src/chat/components/ChatReadReceipt.jsx